import { render } from "./FormComp.vue?vue&type=template&id=aa5d03d4&scoped=true&ts=true"
import script from "./FormComp.vue?vue&type=script&lang=ts"
export * from "./FormComp.vue?vue&type=script&lang=ts"

import "./FormComp.vue?vue&type=style&index=0&id=aa5d03d4&lang=css&scoped=true"

import exportComponent from "C:\\Users\\Ronnald\\Desktop\\page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa5d03d4"]])

export default __exports__